import { ErrorSummary } from '@digdir/designsystemet-react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { useOppvarmingFormContext } from '../../../utils';
import { ErrorGroupWrapper } from '../../formErrors/styledComponents';
import { hasErrors } from '../../formErrors/utils';
import { ErrorLinkItem } from '../../formErrors/errorLinkItem';

// Elektrisitet errors consists of seven categories -  the main category Elektrisitet, with six subgroups:
// "Panelovn", "Gulvvarme", "Luftvarme", "Takvarme" and "Elektrokjel".
export const ElektrisitetErrorSummary = () => {
  const { formState } = useOppvarmingFormContext();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.elektrisitet' });

  // Common error and message for the whole group of checkboxes - we use the one from panelovn and show it once
  const elektrisitetError = formState.errors.elektrisk?.value?.panelovn?.selected;

  const panelovnErrors = formState.errors.elektrisk?.value?.panelovn?.value;
  const gulvvarmeErrors = formState.errors.elektrisk?.value?.gulvvarme?.value;
  const luftvarmeErrors = formState.errors.elektrisk?.value?.luftvarme?.value;
  const takvarmeErrors = formState.errors.elektrisk?.value?.takvarme?.value;
  const elektrokjelErrors = formState.errors.elektrisk?.value?.kjel?.value;
  const varmtvannsberederErrors = formState.errors.elektrisk?.value?.varmtvannsbereder?.value;

  return (
    <Fragment>
      {elektrisitetError && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={elektrisitetError} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}

      {hasErrors(panelovnErrors) && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('panelovn.label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={panelovnErrors?.installasjonsAr} />
            <ErrorLinkItem error={panelovnErrors?.vetInstallasjonsAr} />
            <ErrorLinkItem error={panelovnErrors?.termostatstyring} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}
      {hasErrors(gulvvarmeErrors) && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('gulvvarme.label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={gulvvarmeErrors?.installasjonsAr} />
            <ErrorLinkItem error={gulvvarmeErrors?.vetInstallasjonsAr} />
            <ErrorLinkItem error={gulvvarmeErrors?.termostatstyring} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}
      {hasErrors(elektrokjelErrors) && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('kjel.label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={elektrokjelErrors?.varmesentral?.installasjonsAr} />
            <ErrorLinkItem error={elektrokjelErrors?.varmesentral?.vetInstallasjonsAr} />
            <ErrorLinkItem error={elektrokjelErrors?.varmesentral?.varmesentralType} />
            <ErrorLinkItem error={elektrokjelErrors?.varmesentral?.installertIOppvarmetRom} />
            <ErrorLinkItem error={elektrokjelErrors?.installasjonsAr} />
            <ErrorLinkItem error={elektrokjelErrors?.vetInstallasjonsAr} />
            <ErrorLinkItem error={elektrokjelErrors?.serviceGjennomfortSiste2Ar} />
            <ErrorLinkItem error={elektrokjelErrors?.radiator?.selected} />
            <ErrorLinkItem error={elektrokjelErrors?.radiator?.value?.termostatstyring} />
            <ErrorLinkItem error={elektrokjelErrors?.gulvvarme?.value?.termostatstyring} />
            <ErrorLinkItem error={elektrokjelErrors?.bruk?.romoppvarming} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}
      {hasErrors(luftvarmeErrors) && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('luftvarme.label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={luftvarmeErrors?.installasjonsAr} />
            <ErrorLinkItem error={luftvarmeErrors?.vetInstallasjonsAr} />
            <ErrorLinkItem error={luftvarmeErrors?.termostatstyring} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}
      {hasErrors(takvarmeErrors) && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('takvarme.label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={takvarmeErrors?.installasjonsAr} />
            <ErrorLinkItem error={takvarmeErrors?.vetInstallasjonsAr} />
            <ErrorLinkItem error={takvarmeErrors?.termostatstyring} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}
      {hasErrors(varmtvannsberederErrors) && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={varmtvannsberederErrors?.installasjonsAr} />
            <ErrorLinkItem error={varmtvannsberederErrors?.vetInstallasjonsAr} />
            <ErrorLinkItem error={varmtvannsberederErrors?.installertIOppvarmetRom} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}
    </Fragment>
  );
};
